export default __webpack_public_path__ + "static/media/ic_svc_samsung_free.3f6520ac.png";